module.exports = __webpack_public_path__ + "static/colgadas-002.thumb-94782cffa20da26f839da7737720ab3c.jpg";